module.exports = __webpack_public_path__ + "img/vierge-group.a80ba9c8.svg";